import Heading from './../components/Heading';
import chooseImage from './../assets/pexels/about-2.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsersCog, faPhoneAlt, faUserCheck, faMoneyCheckDollar } from '@fortawesome/free-solid-svg-icons';

const WhyChooseUsSection = () => {
  return (
      <section className='py-10'>
      <Heading name="Why Choose PocketLPO?" tstyle="text-center mb-10"/>
        <div className="grid md:grid-cols-3 gap-8 mt-10 mx-10 mb-8">
          {/* Left Section */}
          <div className="space-y-8">
            <div className="flex flex-col items-start">
            <div className="p-4 bg-emerald-600 text-white flex items-center justify-center w-16 h-16 mb-3">
                <FontAwesomeIcon className="text-xl" icon={faMoneyCheckDollar} />
              </div>
              <h4 className="text-xl font-semibold">Flexible Pricing Models</h4>
              <p className="text-gray-600">Our subscription plans and fixed-fee services are designed to fit your business needs.</p>
            </div>
            <div className="flex flex-col items-start">
            <div className="p-4 bg-emerald-600 text-white flex items-center justify-center w-16 h-16 mb-3">
                <FontAwesomeIcon className="text-xl" icon={faUserCheck} />
              </div>
              <h4 className="text-xl font-semibold">Client-Centric Approach</h4>
              <p className="text-gray-600">Your business success is our priority, and we tailor our services accordingly.</p>
            </div>
          </div>

          {/* Center Image Section */}
          <div className="relative min-h-[400px]">
            <img
              src={chooseImage}
              alt="Feature"
              className="w-full h-full object-cover rounded-lg shadow-md"
            />
          </div>

          {/* Right Section */}
          <div className="space-y-8">
            <div className="flex flex-col items-start">
            <div className="p-4 bg-emerald-600 text-white flex items-center justify-center w-16 h-16 mb-3">
                <FontAwesomeIcon className="text-xl" icon={faUsersCog} />
              </div>
              <h4 className="text-xl font-semibold">Professional Staff</h4>
              <p className="text-gray-600">Our team consists of seasoned legal experts with diverse industry knowledge.</p>
            </div>
            <div className="flex flex-col items-start">
              <div className="p-4 bg-emerald-600 text-white flex items-center justify-center w-16 h-16 mb-3">
                <FontAwesomeIcon className="text-xl" icon={faPhoneAlt} />
              </div>
              <h4 className="text-xl font-semibold">Comprehensive Support:</h4>
              <p className="text-gray-600">We offer a full spectrum of corporate legal services tailored to your goals.</p>
            </div>
          </div>
        </div>
    </section>
  );
};

export default WhyChooseUsSection;

